import {
  DOCTOR_NAMES_LOADING_FAILED,
  DOCTOR_NAMES_LOADING_SUCCESS,
  DOCTORS_SPECIALITIES_LOADING_FAILED,
  DOCTORS_SPECIALITIES_LOADING_SUCCESS,
  SELECT_DOCTOR_NAME,
  SELECT_DOCTORS_SPECIALITY,
  SET_DEFAULT_VALUE,
  CLEAN_NAME_SELECTOR,
} from "../actions/types";

const defaultState = {
  doctorsSpecialities: [],
  doctorNames: [],
  error: null,
  selectedDoctorSpeciality: null,
  selectedDoctorName: null,
};
const updateDoctors = (state, action) => {
  if (!state) {
    return defaultState;
  }

  switch (action.type) {
    case DOCTORS_SPECIALITIES_LOADING_SUCCESS:
      return {
        ...state.doctors,
        doctorsSpecialities: action.payload,
        error: action.error,
      };
    case DOCTORS_SPECIALITIES_LOADING_FAILED:
      return {
        ...state.doctors,
        doctorsSpecialities: null,
        error: action.payload.error,
      };
    case SELECT_DOCTORS_SPECIALITY:
      return {
        ...state.doctors,
        selectedDoctorSpeciality: action.payload,
      };
    case DOCTOR_NAMES_LOADING_SUCCESS:
      return {
        ...state.doctors,
        doctorNames: action.payload,
        error: action.error,
      };
    case DOCTOR_NAMES_LOADING_FAILED:
      return {
        ...state.doctors,
        error: action.payload.error,
      };
    case CLEAN_NAME_SELECTOR:
      return {
        ...state.doctors,
        doctorNames: [],
        selectedDoctorSpeciality: null,
        selectedDoctorName: null,
      };
    case SELECT_DOCTOR_NAME:
      return {
        ...state.doctors,
        selectedDoctorName: action.payload,
      };
    case SET_DEFAULT_VALUE:
      return {
        ...defaultState,
      };
    default:
      return {
        ...state.doctors,
      };
  }
};

export default updateDoctors;
